import * as placeAPI from "../api/place-api";

import { defineStore } from "pinia";
import { IPlaceInfo } from "@/modules/place-module";
import { LocationQueryValue } from "vue-router";

export const usePlaceStore = defineStore("place-store", {
  state: () => ({
    place: null as null | IPlaceInfo,
  }),

  actions: {
    async loadPlaceInfo(place_id: LocationQueryValue | LocationQueryValue[]) {
      const resp = await placeAPI.apiGetPlace(place_id);
      this.place = resp.data.data;
    },

    async setPlaceFavorite(
      place_id: LocationQueryValue | LocationQueryValue[]
    ) {
      await placeAPI.apiSetFavoritePlace(place_id);
      this.place.place.is_favorite = true;
    },

    async setPlaceUnFavorite(
      place_id: LocationQueryValue | LocationQueryValue[]
    ) {
      await placeAPI.apiSetUnFavoritePlace(place_id);
      this.place.place.is_favorite = false;
    },

    blockUserLeaveFeedback() {
      this.place.reviews_meta.user_can_post_review = false;
    },

    clearPlace() {
      this.place = null;
    },
  },
});
